export const currency = "{РУБЛ}";

export const DEFAUL_TASK_REWARD = 100000;